export default {
    namespace: 'Header',
    translations: {
        zh: {
            logo: '未来世界',
            language: {
                label: '语言'
            },
            nav: {
                home: '首页',
                services: '服务',
                ai: 'AI Family',
                news: '新闻中心',
                resources: '资源中心',
                about: '关于我们',
                contact: '联系我们'
            },
            services: {
                tags: {
                    enterprise: 'Enterprise',
                    talent: 'Talent'
                },
                items: {
                    chinaEnt1: '个性化服务（TO B&G）',
                    chinaPer1: '数字化人才服务（TO C）'
                }
            },
            ai: {
                dify: 'Dify 解决方案',
                interview: 'AI 面试系统',
                resume: 'AI 简历分析'
            },
            resources: {
                tags: {
                    news: 'News',
                    talent: 'Talent',
                    experts: 'Experts',
                    cases: 'Cases'
                },
                items: {
                    news: '新闻中心',
                    talent: '人才库',
                    experts: '专家库',
                    cases: '服务案例库'
                }
            },
            contact: {
                tags: {
                    project: 'Business',
                    join: 'Career'
                },
                items: {
                    project: '项目合作',
                    joinUs: '加入未来世界'
                }
            }
        },
        en: {
            logo: 'FUTURE WORLD',
            language: {
                label: 'Language'
            },
            nav: {
                home: 'Home',
                services: 'Services',
                ai: 'AI Family',
                news: 'News Center',
                resources: 'Resource Center',
                about: 'About Us',
                contact: 'Contact Us'
            },
            services: {
                tags: {
                    enterprise: 'Enterprise',
                    talent: 'Talent'
                },
                items: {
                    chinaEnt1: 'Personalized Services (TO B&G)',
                    chinaPer1: 'Digital Talent Services (TO C)'
                }
            },
            ai: {
                dify: 'Dify Solutions',
                interview: 'AI Interview System',
                resume: 'AI Resume Analysis'
            },
            resources: {
                tags: {
                    news: 'News',
                    talent: 'Talent',
                    experts: 'Experts',
                    cases: 'Cases'
                },
                items: {
                    news: 'News Center',
                    talent: 'Talent Pool',
                    experts: 'Expert Pool',
                    cases: 'Service Case Library'
                }
            },
            contact: {
                tags: {
                    project: 'Business',
                    join: 'Career'
                },
                items: {
                    project: 'Project Cooperation',
                    joinUs: 'Join Future World'
                }
            }
        },
        ja: {
            logo: 'ミライワールド',
            language: {
                label: '言語'
            },
            nav: {
                home: 'ホーム',
                services: 'サービス',
                ai: 'AI Family',
                news: 'ニュースセンター',
                resources: 'リソースセンター',
                about: '会社概要',
                contact: 'お問い合わせ'
            },
            services: {
                tags: {
                    enterprise: 'Enterprise',
                    talent: 'Talent'
                },
                items: {
                    chinaEnt1: '個性化サービス（TO B&G）',
                    chinaPer1: 'デジタル人材サービス（TO C）'
                }
            },
            ai: {
                dify: 'Dify ソリューション',
                interview: 'AI 面接システム',
                resume: 'AI 履歴書分析'
            },
            resources: {
                tags: {
                    news: 'News',
                    talent: 'Talent',
                    experts: 'Experts',
                    cases: 'Cases'
                },
                items: {
                    news: 'ニュースセンター',
                    talent: '人材データベース',
                    experts: '専門家データベース',
                    cases: 'サービス事例集'
                }
            },
            contact: {
                tags: {
                    project: 'Business',
                    join: 'Career'
                },
                items: {
                    project: 'プロジェクト協業',
                    joinUs: '未来世界に参加する'
                }
            }
        }
    }
};
